import { Paper } from '@material-ui/core'
import React from 'react'
import { PaperProps } from '@material-ui/core/Paper'
import styled from '../../../theme'

type Type = React.ComponentType<PaperProps>
const ConfigModalWrapper: Type = styled(Paper)<PaperProps>`
  border: none;
  outline: none;
  max-height: 90vh;
  overflow-y: auto;
`

export { ConfigModalWrapper }
